'use client'

import { Modal } from '../modal.tsx'
import { ModalOverlineHeader } from '../organisms/modal-overline-header/modal-overline-header.tsx'

export const FieldModalTitle = ({ children }: { children: string }) => {
  return (
    <Modal.Overline>
      <ModalOverlineHeader>
        <ModalOverlineHeader.Title title={children} />
      </ModalOverlineHeader>
    </Modal.Overline>
  )
}
